import styled, { css } from 'styled-components'
import { SECTION_PROGRESS_GREEN } from '~/pages/anatomyV2/libs/components/SectionProgress/constants'
import { COLORS } from '~/shared/constants/uiConstants'

const CIRCLE_SIZE = 26

export type TCircleState = 'start' | 'completed' | 'current' | 'pending'

export const SectionProgressStyles = {
  Root: styled.div`
    display: flex;
    align-items: center;
    width: 100%;
  `,

  Divider: styled.div`
    border-bottom: 1px solid #eaeaed;
    margin-top: 16px;
  `,

  Circle: styled.div<{ $state: TCircleState; $dimCurrent?: boolean }>`
    flex-shrink: 0;
    width: ${CIRCLE_SIZE}px;
    height: ${CIRCLE_SIZE}px;
    border-radius: 50%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ $state, $dimCurrent }) => {
      if ($state === 'start') {
        return css`
          border: 6px solid ${SECTION_PROGRESS_GREEN};
        `
      }

      if ($state === 'completed') {
        return css`
          background-color: ${SECTION_PROGRESS_GREEN};
        `
      }

      if ($state === 'current') {
        return css`
          border: 2.5px dashed
            ${$dimCurrent ? COLORS.GRAY_400 : SECTION_PROGRESS_GREEN};
        `
      }

      return css`
        border: 2.5px solid ${COLORS.GRAY_400};
      `
    }}
  `,

  Checkmark: styled.svg`
    width: 12px;
    height: 10px;
  `,

  Line: styled.div<{ $isPast: boolean; $fillPercent?: number }>`
    flex: 1;
    height: 2px;
    margin: 0 1px;
    background: ${({ $isPast, $fillPercent }) => {
      if ($fillPercent !== undefined) {
        return `linear-gradient(to right, ${SECTION_PROGRESS_GREEN} ${$fillPercent}%, ${COLORS.GRAY_400} ${$fillPercent}%)`
      }

      return $isPast ? SECTION_PROGRESS_GREEN : COLORS.GRAY_400
    }};
  `,
}
